import "./style.css";
import React from "react";
import logo from "../../../assets/images/logo.png";
import { requestLogout } from "../../../state/user/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Image,
  Badge,
  Popover,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import axios from "axios";
import { CONFIG } from "../../../config";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuIcon from "@mui/icons-material/Menu";
import notificationSound from "../../../assets/sounds/notification.mp3";

const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);
const API_HOST = CONFIG.modules["accounts"].host;

const { Manager } = require("socket.io-client");

const noti = new Audio(notificationSound);

export const Header = ({ openS, handleDrawerOpen, handleDrawerClose }) => {
  let socket;

  const dispatch = useDispatch();
  const history = useHistory();
  const { myData, user } = useSelector((state) => state.user || {});
  const [timeD, setDuration] = useState(null);
  const [myShift, setMyShift] = useState(null);
  const [myAttendance, setMyAttendance] = useState(null);
  const [myNotifications, setMyNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openNotifications = Boolean(anchorEl);

  useEffect(() => {
    if (user) {
      const manager = new Manager(CONFIG.modules["accounts"].socket, {
        reconnectionDelayMax: 10000,
        path: "/accounts",
      });

      socket = manager.socket("/common", {
        query: {
          token: localStorage.getItem("authToken") || "",
        },
      });
      socket.on(`${user._id}-new-notification`, (data) => {
        console.log("yo", data);
        noti.play();
        setMyNotifications([data, ...myNotifications]);
      });
      getNotifications();
    }
  }, [user]);

  useEffect(() => {
    return () => {
      if (socket) {
        socket.removeAllListeners();
      }
    };
  }, []);

  const markAsAllRead = () => {
    axios
      .put(API_HOST + `/mark-as-all-read`)
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setMyNotifications([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const markAsRead = (id, index) => {
    axios
      .put(API_HOST + `/mark-as-read`, {
        id,
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          const notificationsNew = [...myNotifications];
          notificationsNew.splice(index, 1);
          setMyNotifications(notificationsNew);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getNotifications = () => {
    axios
      .get(API_HOST + `/get-my-unseen-notifications`)
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setMyNotifications(resp.data.notifications);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getMyAttendance = () => {
    axios
      .get(API_HOST + `/get-my-attendance`)
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setMyAttendance(resp.data.attend);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const startShift = (end) => {
    axios
      .post(API_HOST + `/start-my-shift`, {
        end,
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setMyAttendance(resp.data.attend);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getMyShift = () => {
    axios
      .get(API_HOST + `/get-my-shift`)
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setMyShift(resp.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    setDuration(null);
    getMyShift();
    getMyAttendance();
  }, []);

  useEffect(() => {
    if (timeD === null) return;
    const intervalId = setInterval(() => {
      setDuration(timeD + 1);
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [timeD]);

  useEffect(() => {
    if (myData && myData.attendance) {
      // setDuration(myData.attendance.seconds)
    }
  }, [myData]);
  useEffect(() => {
    if (myAttendance) {
      if (myAttendance.shiftStartedTime) {
        console.log("Shift Start time exists", myAttendance.shiftStartedTime);
        const secondsDiff = dayjs().diff(
          dayjs(myAttendance.shiftStartedTime),
          "second"
        );
        setDuration(secondsDiff > 0 ? secondsDiff : 0);
      }
    }
  }, [myAttendance]);

  return (
    <Box
      sx={{
        display: "flex",
        height: "4em",
        position: "fixed",
        width: "100vw",
        background: "#F28627",
        boxShadow: 3,
        pl: {
          md: 10,
          xs: 4,
        },
        pr: {
          md: 10,
          xs: 4,
        },
        alignItems: "center",
        zIndex: 237,
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => {
            if (openS) {
              handleDrawerClose();
            } else {
              handleDrawerOpen();
            }
          }}
          edge="start"
          sx={{
            pr: {
              md: 2,
              xs: 1,
            },
          }}
        >
          <MenuIcon />
        </IconButton>

        <Box
          component={"img"}
          src={logo}
          sx={{
            height: {
              md: "3em",
              xs: "2em",
            },
          }}
        ></Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          cursor: "pointer",
          ml: {
            md: 3,
            xs: 1,
          },
        }}
      >
        {myShift && (
          <Box
            sx={{
              borderLeft: "1px solid white",
              borderRight: "1px solid white",
              pl: 1,
              mr: 1,
              pr: 1,
            }}
          >
            <Box>
              <Typography sx={{ color: "white" }}>{`Today's Shift: (${dayjs(
                myShift.start
              ).format("hh:mm:A")}-${dayjs(myShift.end).format(
                "hh:mm:A"
              )})`}</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
              <Typography variant="p" sx={{ color: "white" }}>
                Duration:{" "}
              </Typography>
              <Typography
                variant="h5"
                color={"white"}
                sx={{ fontWeight: "bold" }}
              >
                {" "}
                {""}
                {myAttendance &&
                  !myAttendance.shiftEnded &&
                  myAttendance.shiftStarted &&
                  dayjs.duration(timeD * 1000).format("HH:mm:ss")}
                {myAttendance &&
                  myAttendance.shiftEnded &&
                  dayjs
                    .duration(
                      dayjs(myAttendance.shiftEndedTime).diff(
                        dayjs(myAttendance.shiftStartedTime),
                        "second"
                      ) * 1000
                    )
                    .format("HH:mm:ss")}
                {/* {timeD} */}
              </Typography>
              {myAttendance && !myAttendance.shiftStarted && (
                <Button
                  sx={{ ml: 2 }}
                  variant="contained"
                  size={"small"}
                  onClick={() => {
                    startShift();
                  }}
                >
                  Start
                </Button>
              )}
              {myAttendance &&
                myAttendance.shiftStarted &&
                !myAttendance.shiftEnded && (
                  <Button
                    sx={{ ml: 2 }}
                    variant="contained"
                    size={"small"}
                    onClick={() => {
                      startShift(true);
                    }}
                  >
                    End
                  </Button>
                )}
            </Box>
          </Box>
        )}

        <Box
          sx={{
            mr: {
              md: 3,
              xs: 1,
            },
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => {
            history.push("/apply-leave?open=true");
          }}
        >
          <CalendarMonthOutlinedIcon sx={{ color: "white" }} />
          &nbsp;
          <Typography
            variant="p"
            sx={{
              fontSize: {
                md: ".9em",
                xs: ".7em",
              },
            }}
            color={"white"}
          >
            Apply Leave
          </Typography>
        </Box>
        <Box
          sx={{
            mr: {
              md: 3,
              xs: 1,
            },
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => {}}
        >
          <IconButton
            size="large"
            aria-label="show 17 new notifications"
            color="inherit"
            aria-describedby={"notification-ref"}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
          >
            <Badge badgeContent={myNotifications.length || null} color="error">
              <NotificationsIcon sx={{ color: "white" }} />
            </Badge>
          </IconButton>
          <Popover
            id={"notification-ref"}
            open={openNotifications && myNotifications.length > 0}
            anchorEl={anchorEl}
            onClose={() => {
              setAnchorEl(null);
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <List>
              {myNotifications.map((n, i) => {
                return (
                  <ListItem disablePadding key={i}>
                    <ListItemButton
                      onClick={() => {
                        markAsRead(n._id, i);
                        history.push(n.href);
                      }}
                    >
                      <Typography sx={{ fontSize: ".9em" }}>
                        {n.brief}
                      </Typography>
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
            <hr></hr>
            <Typography
              sx={{
                fontSize: ".8em",
                cursor: "pointer",
                marginLeft: "1em",
                marginBottom: "1em",
                color: "#0669BF",
              }}
              onClick={() => {
                markAsAllRead();
              }}
            >
              Mark as all read
            </Typography>
          </Popover>
          {/* <NotificationsIcon sx={{ color: 'white', }} />&nbsp; */}
        </Box>

        <Box
          sx={{ display: "flex", cursor: "pointer", alignItems: "center" }}
          onClick={() => {
            axios
              .post(API_HOST + "/auth/logout")
              .then((resp) => {
                if (resp.data && resp.data.success) {
                  dispatch(requestLogout());
                  window.location.href = "/login";
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }}
        >
          <LogoutOutlinedIcon sx={{ color: "white" }} />
          <Typography variant="p" color={"white"} sx={{}}>
            Logout
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
